/*
 * Assume data-wwb-link-url on container element
 * Assume .wwb-link-area on clickable elements
 * */
import { isUrlValid } from './lib/helpers';
document.documentElement.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) {
        return;
    }
    // Return if click was inside a regular link inside .wwb-link-area
    if (target.closest('a')) {
        return;
    }
    const linkArea = target.closest('.wwb-link-area');
    if (!linkArea) {
        return;
    }
    const elementWithLinkData = linkArea.closest('[data-wwb-link-url]');
    if (!(elementWithLinkData instanceof HTMLElement)) {
        return;
    }
    const linkUrl = elementWithLinkData.dataset.wwbLinkUrl;
    if (!linkUrl || !isUrlValid(linkUrl)) {
        return;
    }
    window.open(linkUrl, '_self');
});
